import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyCallSettings extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={false} pageTitle={"User Call Settings"} formname={"table_79"} customClass={"field-customization-container org-container callsetting-container"} customFrameClass = {"import-log-container"}/>
        );
    }
}

export default LegacyCallSettings;
